import { MouseEvent } from 'react';
import { TaskStatus } from '../tasks/tasksType';
import { ProviderItemType } from '../providers/providerTypes';

export type DeleteState = 'notDeleted' | 'deleted' | 'all';

export type TaskType = 'progressive' | 'atOnce';

export type AssignmentType =
  | 'does'
  | 'verify'
  | 'taskPublish'
  | 'subTaskPublish';

export type EffectiveDateType =
  | 'startDate'
  | 'dueDate'
  | 'dueVerify'
  | 'creationDate'
  | 'parentStartDate'
  | 'parentDueDate'
  | 'parentDueVerify'
  | 'parentCreationDate';

export type UserType = 'assignee' | 'follower' | 'verifier';

export type TimeType = 'startDate' | 'dueDate' | 'verifyDate';

export type Order =
  | 'creationDate'
  | 'updateDate'
  | 'dueDate'
  | 'startDate'
  | 'id_asc'
  | 'creationDate_asc'
  | 'updateDate_asc'
  | 'dueDate_asc'
  | 'startDate_asc'
  | 'id_desc'
  | 'creationDate_desc'
  | 'updateDate_desc'
  | 'dueDate_desc'
  | 'startDate_desc';

export type NumberOrNull = number | null;

export type StringOrNull = string | null;

export type StringOrUndefined = string | undefined;

export const TimeScaleValues = [
  'day',
  'week',
  'month',
  'season',
  'twoSeason',
  'year',
];

export type Color =
  | 'primary'
  | 'green'
  | 'green-outline'
  | 'orange'
  | 'orange-outline'
  | 'blue'
  | 'blue-outline'
  | 'red'
  | 'red-outline'
  | 'black'
  | 'black-outline'
  | 'gray'
  | 'dark-gray'
  | 'white'
  | 'primary-color'
  | 'primary-outline';

export type loadStatus = 'loading' | 'loaded' | 'notLoaded';

export interface IItemPicker {
  id: number;
  name: string;
  dadId: number;
  type: ProviderItemType;
  order?: number;
}

export interface ISearchParams {
  from?: number; // required
  count?: number; // required
  parentId?: number | null; // required
  text?: string;
  order?: Order;
  status?: TaskStatus;
  itemId?: number;
  toDate?: number;
  archived?: boolean;
  fromDate?: number;
  projectId?: number;
  companyId?: number;
  assigneeId?: number;
  templateId?: number;
  creatorIds?: number;
  deleteState?: DeleteState;
  verifyStatus?: TaskStatus;
  mainProgressTo?: number; // 0 / 99.99 / 100
  mainProgressFrom?: number; // 0 / 0.1 / 100
  secondaryProgressTo?: number; // 0 / 99.99 / 100
  secondaryProgressFrom?: number; // 0 / 0.1 / 100
  includeDrafted?: boolean;
  fieldValues?: { [key: string]: string };
  fieldValuesMap?: { [key: string]: string[] };
  mentioned?: boolean;
  directAddress?: boolean;
  tt?: string;
  printable?: boolean;
  dateOffsetFromNow?: number;
  dateOffsetToNow?: number;
  excludeFields?: { [key: string]: string[] };
  includeProgressHistory?: boolean;
}

export type MenuAction = {
  message: string;
  callBack: (e: MouseEvent<HTMLElement>) => void;
  order: number;
};

export type Tab = 'info' | 'subtasks' | 'conversation' | 'attachments';
